import { FilterChoice } from '../../types/FilterChoice';
import { PathMaker } from '../../types/PathParser';
import {
  BARE_TREATMENTS,
  FIXED_TOPIC_SPELLINGS,
  SPECIAL_CASED_DENTAL_TREATMENTS,
} from './specialCasedTopics';
import { hyphenDecode, hyphenEncode, toSentenceCase } from './util';

export const makeTopicSegment: PathMaker = function* ({ topic, onlineAppointments }) {
  if (!topic) {
    yield 'text';
  } else if (topic.bulkBillingGp) {
    yield 'bulk-billing-gp';
  } else if (topic.specialist) {
    /** This one specific specialist gets a 'dentist' token before it. */
    if (topic.specialist === 'Cosmetic Dentist') {
      yield 'dentist';
    }

    if (topic.specialist === 'GP' && !onlineAppointments) {
      yield 'doctor';
    } else {
      yield hyphenEncode(topic.specialist).toLowerCase();
    }
  } else if (topic.treatment) {
    /** This specific list of dental treatments gets the form 'dentist/treatment/some-treatment'
     * instead of just 'treatment/some-treatment'
     */
    if (SPECIAL_CASED_DENTAL_TREATMENTS.includes(topic.treatment)) yield 'dentist';
    yield 'treatment';
    yield hyphenEncode(topic.treatment).toLowerCase();
  }
};

export const parseTopic = (
  previousToken: string[],
  token: string,
  filters: FilterChoice,
  treatmentExpected: boolean,
) => {
  const topic = normalizeTopicSpelling(toSentenceCase(hyphenDecode(token)), previousToken);

  /** For backwards-compatibility, certain treatments are allowed to appear in the URL without a
   *  treatment separator before them (ie they look like specialists). We recognise this, but will
   *  only ever produce a URL withthe separator present. */
  filters.topic =
    treatmentExpected || BARE_TREATMENTS.has(topic) ? { treatment: topic } : { specialist: topic };
};

export const normalizeTopicSpelling = (token: string, previousToken: string[]) => {
  if (previousToken.includes('appointments') && token === 'GP') {
    return token;
  } else {
    return FIXED_TOPIC_SPELLINGS.get(token) ?? token;
  }
};
